import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NO_ERRORS_SCHEMA } from '@angular/core';

import { App1Component } from './app1.component';
import { App2Component } from './app2.component';

@NgModule({
  imports:      [ BrowserModule, FormsModule ],
  declarations: [ App1Component, App2Component ],
  bootstrap:    [ App1Component, App2Component ],
  schemas:      [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }